module.exports = __webpack_public_path__ + "img/right-2.8b09dbe3.svg";